var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileWithGreatPowercomesGreatSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 600,
    viewBox: "0 0 343 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 600,
    rx: 20,
    fill: "#FAE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_8846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.668 478.903L28.291 413.35L89.1617 304.72L192.173 293.482L312.041 359.972L263.345 459.237L140.668 478.903Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.318 539.719L-64.7754 431.165L36.025 251.276L206.609 232.667L405.108 342.771L324.468 507.153L121.318 539.719Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.56 611.245L-174.232 452.117L-26.4701 188.42L223.588 161.141L514.564 322.542L396.355 563.507L98.56 611.245Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3864 696.65L-304.928 477.135L-101.091 113.367L243.861 75.7363L645.26 298.387L482.191 630.796L71.3864 696.65Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5496 806.14L-472.48 509.208L-196.756 17.1487L269.851 -33.7539L812.813 267.42L592.235 717.06L36.5496 806.14Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1074 389.038L97.5605 331.659L207.751 323.436L270.983 360.139L242.948 417.943L143.576 432.181L72.1074 389.038Z",
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0176 413.075V388.878L143.592 432.189V454.556L72.0176 413.075Z",
    fill: "#C7CDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0176 413.075V388.878L143.592 432.189V454.556L72.0176 413.075Z",
    fill: "url(#paint0_linear_1168_8846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0176 413.075V388.878L143.592 432.189V454.556L72.0176 413.075Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.592 454.55V432.173L243.229 417.274V438.651L143.592 454.55Z",
    fill: "#6870FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.592 454.55V432.173L243.229 417.274V438.651L143.592 454.55Z",
    fill: "url(#paint1_linear_1168_8846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.592 454.55V432.173L243.229 417.274V438.651L143.592 454.55Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.946 382.684V360.221L243.229 417.285V438.675L270.946 382.684Z",
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.946 382.684V360.221L243.229 417.285V438.675L270.946 382.684Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.666 406.928V316.464L237.809 261.426V347.847C237.809 350.646 236.346 353.241 233.952 354.691L147.666 406.928Z",
    fill: "#F7DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.107 401.841C139.439 413.646 132.758 409.743 128.873 406.859L140.107 391.803L156.107 401.841Z",
    fill: "#EBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.883 384.917V299.372L147.665 315.089V398.823C147.665 407.486 138.116 412.75 130.791 408.123L116.805 399.29C111.873 396.175 108.883 390.75 108.883 384.917Z",
    fill: "#F7DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.327 245.163L112.17 292.99C108.298 295.245 108.173 300.794 111.94 303.22L127.375 313.161C135.65 318.491 146.226 318.691 154.697 313.677L235.278 265.983C238.696 263.96 238.504 258.95 234.94 257.195L209.447 244.638C204.637 242.269 198.961 242.466 194.327 245.163Z",
    fill: "#FEF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.734 256.433V302.497C126.734 302.497 129.107 309.088 137.199 308.794C145.291 308.499 147.056 301.585 147.056 301.585C147.056 290.109 145.049 264.398 147.056 254.357C149.381 242.73 152.479 241.127 155.15 236.213C157.821 231.299 177.686 211.509 191.721 208.458C198.754 206.929 200.513 213.045 200.513 216.295V258.536C200.513 258.536 202.929 265.511 210.452 265.608C217.974 265.704 220.2 258.536 220.2 258.536V219.926C220.2 212.018 219.626 202.074 210.452 194.888C198.984 185.904 178.532 187.816 154.067 208.458C134.495 224.972 127.69 247.322 126.734 256.433Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.525 305.91C192.14 305.91 182.15 313.044 179.665 324.257C178.272 330.542 177.346 339.71 186.087 341.362L181.523 368.058C181.233 369.755 183.081 371.002 184.546 370.096L200.917 359.975C202.997 358.689 204.088 356.27 203.676 353.86L200.239 333.771C203.422 328.95 205.773 323.029 206.304 319.469C207.313 312.689 206.909 305.91 199.525 305.91Z",
    fill: "#7A1600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_8846",
    x1: 72.0176,
    y1: 401.037,
    x2: 265.619,
    y2: 563.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1168_8846",
    x1: 143.592,
    y1: 424.175,
    x2: 172.23,
    y2: 481.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7152"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_8846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 303,
    height: 468,
    fill: "white",
    transform: "translate(20 112)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWithGreatPowercomesGreatSecurity);
export default __webpack_public_path__ + "static/media/Mobile - With Great Power comes Great Security.0d28ec15a03309a006a1093c9fe1b769.svg";
export { ForwardRef as ReactComponent };